import { useEffect, useState, useContext } from "react"; 
import { ChatContext } from "../context/ChatContext"; 
import AsyncLocalStorage from '@createnextapp/async-local-storage'; 
import { HomeIcon } from "@heroicons/react/24/outline";
import FeedChatButton from "./FeedChatButton";
import Searchbar from "./Searchbar";
import socket from "../services/socket";

const SideChatFeed = () => {
  const { data, dispatch } = useContext(ChatContext); 
  const [chats, setChats] = useState(data.lastMessages);
  const [currentChat, setCurrentChat] = useState(data.currentChat);
 const [allChats, setAllChats] = useState(data.lastMessages); // full list
 

useEffect(() => {
  // Sort messages: unread first, then by timestamp
  const sortedMessages = [...(data.lastMessages || [])].sort((a, b) => {
    // Prioritize unread messages (assuming direction 0 is incoming)
    const unreadA = a.unread > 0 && a.direction === 0;
    const unreadB = b.unread > 0 && b.direction === 0;

    if (unreadA && !unreadB) return -1; // a comes first
    if (!unreadA && unreadB) return 1;  // b comes first

    // If both are unread or both are read, sort by timestamp (most recent first)
    return b.timestamp - a.timestamp;
  });
  setAllChats(sortedMessages);
    setChats(sortedMessages);
    setCurrentChat(data.currentChat);  
  }, [data.lastMessages, data.currentChat ]);
 
  const HandleSelect = async (chat) => {    

    let client_id = await AsyncLocalStorage.getItem("silu-ClientId");
    if (client_id) { 
      socket.emit("set-channel", {clientId: client_id, channelId: chat.channel_id} );
    }   
    dispatch({ type: "CHANGE_CHAT", payload: chat.channel_id });
    dispatch({ type: "SET_CATEGORY", payload: chat.category });
    dispatch({ type: "SET_CHAT", payload: chat }); 
    setCurrentChat(chat);
    // Then reset the view, which will use the new accountNo to decide on loading
    dispatch({ type: "RESET_ACCOUNT_VIEW" }); 
  }; 

const filterSearch = (text) => {
  if (!text) {
    setChats(allChats); // restore full list
  } else {
    setChats(
      allChats.filter(chat =>
        chat.name?.toLowerCase().includes(text.toLowerCase())
      )
    );
  }
};
 

 return (
    <div className="flex flex-col flex-1 bg-transparent">  
          <div className="sticky top-0 z-10 bg-white/80 backdrop-blur-md p-4 shadow-sm">  
            <Searchbar filterSearch={filterSearch} />
          </div>
          <div className="flex-1 overflow-y-auto">
            <ul role="list" className="space-y-3 p-4">  
              {Array.isArray(chats) && chats.map((chat) => (
                <li key={chat.chat_id} className="list-none">
                  <FeedChatButton
                    message={chat}
                    currentChat={currentChat}
                    handleSelect={HandleSelect}
                  />
                </li>
              ))}
            </ul>
          </div>
        </div>
 )
};

export default SideChatFeed;
